import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { NgFor, NgIf } from '@angular/common';
import { RecaptchaModule } from 'ng-recaptcha';
import { DatasearchService } from '../../_services/datasearch.service';
import { BusyService } from '../../_services/busy.service';
import { getCountries, getCountryCallingCode } from 'libphonenumber-js'; // @ts-ignore
import * as bootstrap from 'bootstrap';
declare var $: any;
@Component({
  selector: 'app-career-at',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    NgFor,
    RecaptchaModule,
    FormsModule,
    ReactiveFormsModule,
    NgIf,
  ],
  templateUrl: './career-at.component.html',
  styleUrls: ['./career-at.component.scss'],
})
export class CareerAtComponent implements OnInit {
  @ViewChild('selectPhotos') selectPhotos: any;
  @ViewChild('applyModal') applyModal!: ElementRef;
  transparent = false;
  careerForm: FormGroup = this.fb.group({});
  head: any[] = [];
  currentPage: string = 'career';
  jobs: any = [];
  errorMessage: any;
  selectedJob: any;
  formSubmitted = false;
  formInitilized = false;
  document: File | undefined = undefined;
  upload_cv: any;
  countries: any[] = [];
  originalCountries: any[] = [];
  selectedFile: File | null = null;
  recaptchaResponse: string | null = null;
  recaptchaSiteKey = '6LfvdWgqAAAAAB4irdmbPCmlpmyBzGLjGVIrHE_S';
  filePath = '/public_html/agropat/uploads/CV';
  constructor(private fb: FormBuilder, private datasearch: DatasearchService) {}

  ngOnInit() {
    this.loadCountryCodes();
    this.getCareerJobs();
    this.initialiseForm();
    this.getHeading();
  }
  getCareerJobs() {
    this.datasearch.getCareerAtjobs().subscribe(
      (res) => {
        if (res && res.success) {
          this.jobs = res.data.filter((job: any) => job.isActive === true);
        } else {
          this.jobs = [];
        }
      },
      (error) => {
        console.error('Error fetching career jobs', error);
        this.jobs = [];
      }
    );
  }
  loadCountryCodes() {
    const uniqueCountries = new Map();
    getCountries().forEach((country) => {
      const code = `+${getCountryCallingCode(country)}`;
      const flag = `https://flagcdn.com/16x12/${country.toLowerCase()}.png`;
      if (!uniqueCountries.has(code)) {
        uniqueCountries.set(code, { code, flag });
      }
    });
    this.countries = Array.from(uniqueCountries.values());
  }

  initialiseForm() {
    this.careerForm = this.fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      city: ['', [Validators.required]],
      number: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      subject: ['', [Validators.required]],
      message: ['', [Validators.required]],
      country_code: ['+91', [Validators.required]],
      query_type: ['job'],
      cv: ['', [Validators.required]],
    });
  }
  // onCaptchaSuccess(token: string) {
  //   console.log('reCAPTCHA resolved with token:', token);
  //   this.careerForm.get('recaptcha')?.setValue(token); // Set the token in the form control
  // }
  onCaptchaSuccess(token: string | null) {
    this.recaptchaResponse = token;
  }

  // Reset reCAPTCHA
  resetCaptcha() {
    this.recaptchaResponse = null; // Reset the response manually
  }
  openModal(job: any) {
    this.selectedJob = job;
    this.careerForm.patchValue({
      subject: job.title, // Autofill the subject with the job title
    });
  }

 // Rename the method to avoid conflict
openApplyModal(title: string): void {
  this.careerForm.patchValue({
    subject: title, // Autofill the subject with the given title
  });
}


  onBrowse() {
    this.selectPhotos.nativeElement.click();
  }

  photosSelect(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.careerForm.controls['cv'].setValue(
        `cv_${Date.now()}${this.selectedFile.name.substring(
          this.selectedFile.name.lastIndexOf('.')
        )}`
      );
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      // this.selectedFile = event.dataTransfer.files[0];
      this.documentDrop(event.dataTransfer.files);
    }
  }

  fileupload() {
    let postdata: any = {
      file: this.selectedFile,
    };
    this.datasearch.postFileUpdate(postdata).subscribe(
      (response) => {},
      (error) => {
        console.log(error);
      }
    );
  }
  // submit_career_form() {
  //   this.formSubmitted = true;
  //   if (this.careerForm.valid) {
  //     this.document ? this.cvUpload() : this.submitJobForm();
  //   } else {
  //     this.errorMessage = 'Please fill out all required fields correctly.';
  //   }
  // }
  // submit_career_form() {
  //   this.formSubmitted = true;

  //   // Check if the form is valid and reCAPTCHA is verified
  //   // if (this.careerForm.valid && this.recaptchaResponse) {
  //   if (this.careerForm.valid) {
  //     this.document ? this.cvUpload() : this.submitJobForm();
  //   } else if (!this.recaptchaResponse) {
  //     this.errorMessage = 'Please verify you are not a robot.';
  //   } else {
  //     this.errorMessage = 'Please fill out all required fields correctly.';
  //   }
  // }
  submit_career_form() {
    
    // Check if the form is valid and reCAPTCHA is completed, and file is uploaded
    if (this.careerForm.valid && this.recaptchaResponse && this.document) {
      this.formSubmitted = true;
      this.cvUpload(); // Proceed with file upload and form submission
    } else {
      // Handle form errors and show appropriate messages
      if (!this.document) {
        this.errorMessage = 'Please upload your CV.';
      } else if (!this.recaptchaResponse) {
        this.errorMessage = 'Please verify you are not a robot.';
      } else {
        this.errorMessage = 'Please fill out all required fields correctly.';
      }
    }
  }
  
  
  async cvUpload() {
    const uploadFile: any = await this.uploadFile().toPromise();
    if (uploadFile && uploadFile.message === 'File uploaded successfully') {
      // this.toastr.success(uploadFile.message);
      this.submitJobForm();
    } else {
      // this.toastr.error('Error in uploading image');
      alert('Error in uploading image');
    }
  }
  submitJobForm() {
    let postdata: any = {
      data: this.careerForm.value,
      date: new Date().toLocaleString(),
    };
    this.datasearch.sendInquiryForm(postdata).subscribe(
      (response) => {
        this.closecarrerModal();
        this.careerForm.reset();
        this.document = undefined;
        this.resetCaptcha();
        this.careerForm.reset({ country_code: '+91' });
        this.showToast();
        this.formSubmitted = false;
        
        // Refresh the page after a successful response
        setTimeout(() => {
          window.location.reload();
        }, 800); // Refresh the page after 3 seconds, adjust the time as needed
      },
      (error) => {
        console.log(error);
      }
    );
}

  showToast() {
    window.scrollTo(0, 0);
    const toastElement = document.getElementById('formSuccessToast');
    if (toastElement) {
      const toast = new bootstrap.Toast(toastElement);
      toast.show();
    } else {
      // console.error('Toast element not found');
    }
  }
  
  uploadFile() {
    let formdata = new FormData();
    if (this.document) {
      formdata.append('myfile[]', this.document, `${this.careerForm.value.cv}`);
    } else {
      alert('Document is undefined');
    }
    // formdata.append('myfile[]', this.document, `${this.careerForm.value.cv}`);
    formdata.append('topath', this.filePath);
    return this.datasearch.postFileUpdate_careerat(formdata);
  }

  closecarrerModal() {
    const modalElement = document.getElementById('apply');
    if (modalElement) {
      $('#apply').modal('hide');
    }
  }
  getHeading() {
    this.datasearch.getAllHeadings().subscribe((res) => {
      if (res.success) {
        this.head = res.data.filter(
          (heading: any) => heading.page === this.currentPage
        );
      }
    });
  }

  async documentSelect(doc: any) {
    this.document = null!;
    this.upload_cv = undefined;
    if (doc.target.files) {
      this.document = doc.target.files[0];
      this.careerForm.controls['cv'].setValue(
        `cv_${Date.now()}${this.document?.name.substring(
          this.document?.name.lastIndexOf('.')
        )}`
      );
    }
  }

  async documentDrop(doc: any) {
    this.document = null!;
    this.upload_cv = undefined;
    if (doc) {
      this.document = doc[0];
      this.careerForm.controls['cv'].setValue(
        `cv_${Date.now()}${this.document?.name.substring(
          this.document?.name.lastIndexOf('.')
        )}`
      );
    }
  }
  openLink(url: string) {
    if (url) {
      window.open(url, '_blank');
    }
  }
}
